<div class="mb-3 d-flex justify-content-between">
  <h1 class="fs-5 fw-bold mb-0">Async Tasks</h1>
  <button class="btn btn-primary fw-bold" (click)="openRun()">Run Task</button>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-header fw-bold bg-tertiary p-3 border-0">
    <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-filter me-2 text-primary"></i>Filters</h2></div>
    <div class="card-body">
      <!-- Filters -->
      <div class="row g-3 align-items-end mb-4">
        <div class="col-12">
          <app-date-range-selector [date]="'this-month'"></app-date-range-selector>
        </div>
        <div class="col-auto ms-auto">
          <button type="submit" class="btn btn-primary fw-bold" (click)="applyFilters()">Apply Filters</button>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-striped table-hover table-fixed-columns my-4">
          <thead>
            <tr [tableSorter]="tableSorter" (tableSorterChange)="refresh()">
              <th tableSorterHeader="id">ID</th>
              <th>Description</th>
              <th>Command</th>
              <th tableSorterHeader="startedAt">Started At</th>
              <th tableSorterHeader="endedAt">Ended At</th>
              <th>Status</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (command of asyncCommands; track command) {
              <tr>
                <td>{{ command.id }}</td>
                <td>{{ command.description }}</td>
                <td class="font-monospace small">{{ command.buildCommandLine() }}</td>
                <td>{{ command.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td>{{ command.startedAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td>{{ command.endedAt ? (command.endedAt | date: 'dd/MM/yyyy HH:mm:ss') : '-' }}</td>
                <td [ngClass]="getStatusColor(command.status)" class="fw-bold">{{ command.status }}</td>
                <td>
                  @if (command.id) {
                    <button (click)="openDetail(command)" class="btn btn-primary btn-sm">
                      <i class="bi bi-eye-fill"></i>
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <app-paginator (pageChange)="refresh()" [paginator]="paginator"></app-paginator>
    </div>
  </div>
